import { render, staticRenderFns } from "./WillBeneficiariesIllnessWorkingPeople.vue?vue&type=template&id=1682c766"
import script from "./WillBeneficiariesIllnessWorkingPeople.vue?vue&type=script&lang=js"
export * from "./WillBeneficiariesIllnessWorkingPeople.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports